import { Result } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useWhInfoFiltersStore } from 'shared/stores/use-wh-info-filters';
import { WhInfoBoard } from 'components/wh-info/wh-info-board';
import { WhInfoFilters } from 'components/wh-info/wh-info-filters';

export const WhInfoPage = () => {
  const { filters } = useWhInfoFiltersStore();

  const header = <PageHeader title={<WhInfoFilters />} />;

  return (
    <DefaultPageLayout header={header}>
      {filters?.warehouseId ? (
        <WhInfoBoard />
      ) : (
        <Result
          icon={<ShopOutlined />}
          title='Select a warehouse'
          subTitle='Please select a warehouse to view its information'
          status='info'
        />
      )}
    </DefaultPageLayout>
  );
};
